<template>
  <div>
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">ADMINISTRATOR</div>
      <div class="d-flex m__t--45">
        <template v-for="(tab, index) in tabMenu">
          <div
            v-if="tab.show"
            :key="tab.label"
            :class="[
              { 'm__r--35': index < tabMenu.length - 1 },
              tab.active ? 'tab-experience-manager-active' : 'tab-experience-manager'
            ]"
            @click="$router.replace(tab.url)"
          >
            {{ tab.label }}
          </div>
        </template>
      </div>
    </div>

    <div class="studio-page-administrator-content">
      <div class="custom-table-search">
        <v-server-table
          v-show="load_first"
          ref="tableLocation"
          :columns="columns"
          :options="options"
          class="jTable"
          @loading="loading"
          @loaded="loaded"
          @row-click="onRowClick">
          <div
            slot="beforeFilter"
            class="custom-search">
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <b-button
                class="btn btn-import-oos m__r--5"
                @click="createLocationButton">
                <i class="fa fa-plus fa-lg"/> Add
              </b-button>
              <j-import-file-oos
                v-if="default_import"
                :href-sample="require('@/assets/file/create-location.xlsx')"
                @import-data="importData"/>
              <j-select
                v-model="select_type"
                :disabled="false"
                :options="options_search"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-group>
                <b-form-input
                  ref="filterInput"
                  v-model="filter_data"
                  placeholder="Search"
                  class="m__r--5"/>
              </b-form-group>
            </b-form>
          </div>
          <div
            slot="pic"
            slot-scope="props"
          >
            {{ props.row.organigram.name }}
          </div>
          <div
            slot="created_date"
            slot-scope="props"
          >
            {{ props.row.created_date | moment("MMM DD, YYYY") }}
          </div>
          <div
            slot="updated_date"
            slot-scope="props"
          >
            {{ props.row.updated_date | moment("MMM DD, YYYY") }}
          </div>
        </v-server-table>
        <j-progress-screen
          ref="ImportFile"
          :data-kirim="data_import"
          :url-api="url"
          :headers="headers"
          property-data="data"
          @finish="uploadDone"/>
      </div>
    </div>
  </div>
</template>
<script>
import jApiListLocation from '@/services/jApiLocation';
import { mapActions, mapState } from 'vuex';
import Vue from 'vue';

export default {
  components: {
  },
  data() {
    return {
      popoverSearchShow: false,
      default_import: true,
      load_first: false,
      select_type: 'name',
      options_search: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Code',
          value: 'code',
        },
      ],
      is_finish: false,
      list_error: [],
      error_data: [],
      is_error: false,
      column: ['NAME', 'CODE', 'ERROR'],
      data_import: [],
      raw_data: null,
      is_search_filter: false,
      length_table: '',
      location_data: null,
      columns: ['id', 'name', 'code', 'type', 'pic', 'created_date', 'updated_date'],
      option: {
        filterable: false,
        perPage: 5,
        perPageValues: [5, 10, 20, 50, 100],
      },
      filter_data: '',
      options: {
        headings: {
          id: 'ID',
          name: 'LOCATION',
          code: 'CODE',
          type: 'TYPE',
          pic: 'PIC',
          created_date: 'CREATED DATE',
          updated_date: 'UPDATED DATE',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        filterable: true,
        sortable: ['id', 'name', 'code', 'type', 'created_date', 'updated_date'],
        perPage: 5,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : 'created_date',
              ascending: !data.ascending,
              query: data.query ? data.query : '',
              query_type: 'id',
            },
          };
        },
        requestFunction(data) {
          const locationList = jApiListLocation.companyListLocation(data);
          return locationList.catch((e) => {
            this.dispatch('error', e);
            this.$store.commit('jStoreNotificationScreen/toggleStateProblem', e.message);
          });
        },
        responseAdapter(data) {
          if (data.length) {
            this.length_table = data.length;
          }
          return {
            data: data.data,
            count: data.length,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
    ...mapState('jStoreLogin', ['profile_data']),

    role() {
      return Number(localStorage.getItem('userRole') || this.profile_data.userRole);
    },
    url() {
      const baseUrl = process.env.GATE_URL;
      const getEnv = `${baseUrl}/company/setup/location/create`;
      return getEnv;
    },
    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
    tabMenu() {
      return [
        { url: '/administrator', label: 'USER', show: true, active: false },
        { url: '/administrator/position', label: 'POSITION', show: true, active: false },
        { url: '/administrator/unit', label: 'UNIT', show: true, active: false },
        { url: '/administrator/location', label: 'LOCATION', show: true, active: true },
        { url: '/administrator/layer', label: 'LAYER', show: true, active: false },
        { url: '/administrator/company/profile', label: 'COMPANY', show: true, active: false },
        { url: '/administrator/company/settings', label: 'SETTINGS', show: this.role === 1, active: false },
      ];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.params': function () {
      this.$forceUpdate();
    },
    filter_data(val) {
      this.is_search_filter = true;
      if (val === '') {
        this.$refs.tableLocation.setFilter('');
      }
    },
    load_first(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.filterInput.focus();
        }, 200);
      }
    },
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'toggleProblem', 'showLoading', 'hideLoading', 'loading_screen']),
    ...mapActions('jStoreLocation', ['createCompanyLocation']),
    filter(val) {
      this.$refs.tableLocation.refresh(val);
    },
    createLocation(data) {
      data.forEach((element) => {
        const obj = {
          name: element.NAME,
          code: element.CODE,
          type: element.TYPE,
          pic_organigram_id: element.PIC_ID,
        };
        this.createCompanyLocation(obj);
      });
    },
    uploadData() {
      this.$refs.ImportFile.toggleIsVisible();
    },
    uploadDone() {
      this.raw_data = [];
      this.is_finish = true;
      this.refreshTable();
      this.data_import = [];
      this.default_import = false;
      setTimeout(() => {
        this.default_import = true;
      }, 100);
    },
    refreshTable() {
      this.$refs.tableLocation.refresh();
    },
    importData(val) {
      this.data_import = [];
      this.is_error = false;
      this.list_error = [];
      this.error_data = val;

      const keys = Object.keys(val[0]);
      if (keys[0] !== 'NAME' || keys[1] !== 'CODE' || keys[2] !== 'TYPE' || keys[3] !== 'PIC' || keys[4] !== 'PIC_ID') {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Please use header format correctly');
      }

      this.raw_data = val;
      this.data_import = this.raw_data.map((raw, index) => this.genData(raw, index));

      setTimeout(() => {
        this.uploadData();
      }, 100);
    },
    genData(val, indexData) {
      this.list_error[indexData] = [];
      this.$set(this.error_data[indexData], 'ERROR', []);
      const packing = {
        name: '',
        code: '',
        type: '',
        pic_organigram_id: '',
      };

      // name validations
      const strName = val.NAME ? val.NAME.trim() : '';
      if (val.NAME === undefined || strName.length === 0) {
        this.is_error = true;
        this.list_error[indexData].push('- field name is required');
        this.error_data[indexData].ERROR.push('- field name is required');
      } else {
        this.$set(packing, 'name', val.NAME);
      }

      // code validation
      const strCode = val.CODE ? val.CODE.trim() : '';
      if (val.CODE === undefined || strCode.length === 0) {
        this.is_error = true;
        this.list_error[indexData].push('- field code is required');
        this.error_data[indexData].ERROR.push('- field code is required');
      } else {
        this.$set(packing, 'code', val.CODE);
      }

      // type validations
      const strType = val.TYPE ? val.TYPE.trim() : '';
      if (val.TYPE === undefined || strType.length === 0) {
        this.is_error = true;
        this.list_error[indexData].push('- field type is required');
        this.error_data[indexData].ERROR.push('- field type is required');
      } else {
        this.$set(packing, 'type', val.TYPE);
      }

      // pic validations
      const strPic = val.PIC_ID ? val.PIC_ID.trim() : '';
      if (val.PIC_ID === undefined || strPic.length === 0) {
        this.is_error = true;
        this.list_error[indexData].push('- field pic is required');
        this.error_data[indexData].ERROR.push('- field pic is required');
      } else {
        this.$set(packing, 'pic_organigram_id', val.PIC_ID);
      }

      // this.data_import.push(packing);
      return packing;
    },
    onRowClick({ row }) {
      this.$emit('detail-location', row);
      this.$emit('edit-modal', true);
    },
    createLocationButton() {
      this.$emit('create-modal', true);
    },
    loading(data) {
      const dataParam = data.pagination;
      dataParam.query_type = this.select_type;
      dataParam.query = this.filter_data;
      if (this.load_first) {
        this.showLoading();
      }
    },
    loaded() {
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
        this.hideLoading();
      }
    },
  },
};
</script>
<style lang="scss">

  .w-100{
    width: 100%;
  }
  .grid{
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .field-input__location{
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-gap: 0px 10px;
    height:20px
  }

  .list-data-table .popover {
    max-width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/views/location/jListCompanyLocation.vue